module.exports = __webpack_public_path__ + "static/media/truck.4f2f48ae.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/qci/sprites/gameMailDelivery/truck.png
// module id = 2496
// module chunks = 0